export const types = {
  getAll: '[main] Get all data',
  setAccounts: '[main] Post accounts',
  clearData: '[main] Clear Data'
};
